// Front-end only — no back-end counterpart.

export type SmsConsentFlow = 'customer' | 'partner'

export const SmsConsentFlow = {
  CUSTOMER: 'customer',
  PARTNER: 'partner'
} satisfies Record<string, SmsConsentFlow>

export const SmsConsentFlowValues: readonly SmsConsentFlow[] = Object.values(SmsConsentFlow)
